// extracted by mini-css-extract-plugin
export default {"hidden":"ButtonsBox_hidden__0qcN+","buttonsBox":"ButtonsBox_buttonsBox__jUsgG","favBtn":"ButtonsBox_favBtn__LRGAY"};